import { withInstall } from '@pc-fx-framework/utils/with-install'
import VStackedBarChart from './src/index.vue'

export const FxVStackedBarChart = withInstall(VStackedBarChart)
export default FxVStackedBarChart

export * from './src/types'
